import { Controller } from "@hotwired/stimulus"
import { formatAs } from "web/services/format"

export default class MoneyFieldController extends Controller {
  static targets = ["input", "hiddenInput"]
  static values = {
    currencyCode: String,
  }

  inputTargetConnected() {
    if (!!this.hiddenInputTarget.value) {
      this.inputTarget.value = this.#formattedValue()
    }
  }

  displayFormattedValue() {
    this.inputTarget.type = "text"
    this.inputTarget.value = this.#formattedValue()
  }

  displayEditValue() {
    this.inputTarget.type = "number"
    this.inputTarget.step = "any"
    this.inputTarget.value = this.hiddenInputTarget.value
  }

  update(event) {
    this.hiddenInputTarget.value = event.target.value
    this.hiddenInputTarget.dispatchEvent(new Event("change"))

    this.displayFormattedValue()
  }

  #formattedValue() {
    return formatAs("Money", {
      value: this.hiddenInputTarget.value,
      unit: this.currencyCodeValue,
    })
  }
}
